import { BLOCK_TYPES } from '../blocks/types.js';
import { SERVICE_CATALOG, servicePath } from '../../navigation/serviceCatalog.js';

// Service Content Phase 1 — Airport Transfer (flagship service page). Authored FRENCH content composed
// exclusively from existing Content-Platform blocks and VERIFIED facts already live on the site:
//   - real-time flight tracking  (locales: services.airport "Real-time flight tracking")
//   - 24/7 availability          (locales + JSON-LD openingHoursSpecification)
//   - fixed price known upfront  (home/About: "tarifs fixes", "le prix annoncé est le prix final")
//   - online booking             (locales: "Confirm your ride in less than 2 minutes, 24/7")
//   - premium, comfortable vehicles — described brand-neutrally (Owner correction, PR #250): the
//     page communicates quality/comfort WITHOUT naming a brand/model, so it makes no hard
//     operational promise that a specific vehicle will always be used
//   - Nantes / Loire-Atlantique service area + Angers/Rennes/La Roche-sur-Yon (ratified SAB areaServed)
// NO fabricated claims: no reviews, ratings, statistics, years of experience, awards, partnerships,
// meet-and-greet (name sign) or terminal-specific pickup details. Presentation copy only — business
// facts/identity stay in sabProfile/jsonld; this module adds copy, not facts. The RelatedContent mesh
// is derived from the ratified catalogue so the WP-3.4 internal-link topology is preserved exactly.

const SLUG = 'airport-transfer';
const siblings = SERVICE_CATALOG
  .filter((s) => s.slug !== SLUG)
  .map((s) => ({ label: s.name, to: servicePath(s.slug) }));

export default {
  blocks: [
    {
      type: BLOCK_TYPES.HERO,
      kicker: 'Chauffeur privé premium',
      title: 'Transfert aéroport Nantes Atlantique',
      lead:
        'Un chauffeur privé pour vos trajets vers et depuis l’aéroport de Nantes Atlantique — ponctuel, confortable et au tarif fixe connu à l’avance.',
    },
    {
      type: BLOCK_TYPES.INTRO,
      text:
        'Black Matte assure vos transferts aéroport à Nantes et en Loire-Atlantique, avec des véhicules haut de gamme et un service personnalisé, réservable en ligne et disponible 24h/24, 7j/7.',
    },
    {
      type: BLOCK_TYPES.RICH_TEXT,
      heading: 'Pourquoi réserver votre transfert aéroport avec Black Matte',
      body: [
        'Prendre l’avion impose des horaires précis. Votre chauffeur suit votre vol en temps réel : en cas d’avance ou de retard, votre prise en charge est ajustée pour une arrivée sereine, à l’aéroport comme à votre destination.',
        'Le tarif est fixe et communiqué avant la réservation : pas de majoration de dernière minute, pas de surprise à l’arrivée. Vous voyagez à bord d’un véhicule haut de gamme, confortable et soigné, conduit par un chauffeur privé professionnel et discret.',
      ],
    },
    {
      type: BLOCK_TYPES.FEATURE_GRID,
      heading: 'Un service pensé pour l’aéroport',
      items: [
        { title: 'Tarif fixe', text: 'Le prix est connu et confirmé avant la réservation, sans majoration de dernière minute.' },
        { title: 'Ponctualité', text: 'Suivi des vols en temps réel et prise en charge à l’heure, à l’aller comme au retour.' },
        { title: 'Confort', text: 'Un véhicule haut de gamme, berline ou van adapté à votre trajet et à vos bagages.' },
        { title: 'Réservation en ligne', text: 'Réservez votre transfert en quelques minutes, 24h/24 et 7j/7.' },
      ],
    },
    {
      type: BLOCK_TYPES.STEPS,
      heading: 'Comment réserver votre transfert',
      steps: [
        { title: 'Indiquez votre trajet', text: 'Renseignez votre adresse, l’aéroport de Nantes Atlantique et l’heure souhaitée.' },
        { title: 'Obtenez votre tarif fixe', text: 'Votre prix est calculé et communiqué avant de confirmer la réservation.' },
        { title: 'Confirmez en ligne', text: 'Validez votre réservation en quelques minutes, directement en ligne.' },
        { title: 'Votre chauffeur vous attend', text: 'Votre chauffeur suit votre vol et vous prend en charge à l’aéroport ou à votre adresse.' },
      ],
    },
    {
      type: BLOCK_TYPES.RICH_TEXT,
      heading: 'Nantes Atlantique et toute la Loire-Atlantique',
      body: [
        'Que vous arriviez à l’aéroport de Nantes Atlantique ou que vous deviez y être déposé pour un vol matinal, Black Matte assure un trajet porte-à-porte, sans stationnement ni correspondance à gérer.',
        'Notre service couvre Nantes et sa région, ainsi qu’Angers, Rennes et La Roche-sur-Yon, 24h/24 et 7j/7 — pour un transfert fiable quelle que soit l’heure de votre vol.',
      ],
    },
    {
      type: BLOCK_TYPES.CTA,
      heading: 'Réservez votre transfert aéroport',
      text: 'Obtenez votre tarif fixe et réservez votre chauffeur privé pour l’aéroport de Nantes Atlantique.',
      actions: [
        { label: 'Réserver', to: '/reserver' },
        { label: 'Tous les services', to: '/services' },
      ],
    },
    {
      type: BLOCK_TYPES.RELATED_CONTENT,
      heading: 'Autres prestations',
      links: siblings,
    },
  ],
};
